export enum PermitionEnum {
    MoveEntity,
    MoveFolder,

    SetMassForceOn,
    AdminPrivilege,

    ViewDashboardUI,

    ViewChannelsUI,
    CreateChannel,
    UpdateChannel,
    DeleteChannel,
    GetChannelInfo,
    CreatePost,
    UpdatePost,

    ViewStylesUI,
    CreateStyles,
    UpdateStyles,

    ViewDesignButtonStylesUI,
    UpdateDesignButtonStyles,
    CreateDesignButtonStyles,

    ViewChannelStylesUI,

    ViewUsersUI,
    GetUserDetails,
    GetAccessControlList,

    ViewTemplatesUI,
    CreateTemplate,
    UpdateTemplate,

    ViewStagesUI,
    UpdateStage,
    CreateStage,

    ViewBackgroundsUI,
    CreateBackground,
    UpdateBackground,

    ViewChannelGroupsUI,
    CreateChannelGroup,
    UpdateChannelGroup,

    ViewSolutionsUI,
    CreateSolution,
    UpdateSolution,
    DeleteSolution,
    DragSolution,

    ViewContentTemplatesUI,
    CreateContentTemplate,
    UpdateContentTemplate,

    ViewPlayersUI,
    CreatePlayer,
    UpdatePlayer,
    GetPlayerMonitors,
    CreatePlayerMonitor,
    UpdatePlayerMonitor,

    ViewUserProfileUI,

    ViewFolderTreeUI,

    ViewSettingsUI,

    ViewFontsUI,

    ViewPowerPlansUI,
    GetPowerPlanDetails,

    ViewContractsUI,

    GetEditorProfiles,
    CreateEditorProfile,
    UpdateEditorProfile,

    UpdateApplicationSettings,

    GetActivityLogs,

    GetFiles,

    DownloadReport,
    DownloadUserReport,

    GetUserGroups,
    CreateUserGroup,
    UpdateUserGroup,

    ViewAuthorizationsUI,
    CreateAuthorization,
    UpdateAuthorization,

    ViewCustomExtensionsUI,
    CreateCustomExtension,
    UpdateCustomExtension,
    ViewCustomExtensionsRenderUI
}

export function HavePermition(permitions: Array<string>, action: string): boolean {
    return permitions.some((permition: string) => permition === action);
}
